module.exports = require("./ce.d.ts");